import { AppointmentUserV2Fragment, CareType } from '../graphQL';

export type UserWithAppointmentStatuses = Pick<
  AppointmentUserV2Fragment,
  'careTypeAppointmentStatuses'
>;

type HasCareType = {
  careType: CareType;
};

export const findStatusByCareType = <T extends HasCareType>(
  statuses: T[] | undefined | null,
  careType: CareType
): T | undefined => statuses?.find(s => s.careType === careType);
